var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPrompt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.79663 14.4424V12.1674H11.1613V14.4424H3.79663ZM3.79663 10.2571V7.98207H15.0717V10.2571H3.79663ZM3.79663 6.07175V3.79672H15.0717V6.07175H3.79663ZM12.964 20.2033V16.9609L18.5249 11.425C18.6869 11.2623 18.8668 11.1449 19.0648 11.0726C19.2627 11.0003 19.4607 10.9641 19.6586 10.9641C19.8745 10.9641 20.0812 11.0046 20.2787 11.0856C20.4762 11.1666 20.6557 11.288 20.8173 11.45L21.7423 12.375C21.8869 12.5369 21.9998 12.7169 22.0812 12.9148C22.1625 13.1128 22.2032 13.3107 22.2032 13.5087C22.2032 13.712 22.1669 13.9154 22.0942 14.119C22.0216 14.3226 21.9043 14.5054 21.7423 14.6674L16.2064 20.2033H12.964ZM14.5836 18.5837H15.5336L18.5347 15.5576L18.0847 15.0826L17.6097 14.6326L14.5836 17.6337V18.5837ZM18.0847 15.0826L17.6097 14.6326L18.5347 15.5576L18.0847 15.0826Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrompt);
export default __webpack_public_path__ + "static/media/icon-prompt.236223aa56d27dc92a9e546695a60bc7.svg";
export { ForwardRef as ReactComponent };